//Creates block categories
var causes = ["allowed", "denied"];

//Gets date into correct format
var parseDate = d3.time.format("%Y").parse;

//Sets up margins
var margin = {top: 5, right: 5, bottom: 25, left: 37};

var widther = d3.select(".gia-chart-wrapper").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 330 - margin.top - margin.bottom;

//Defines xScale
var xScale = d3.scale.ordinal()
    .rangeRoundBands([0, width], 0.1);

//Defines yScale
var yScale = d3.scale.linear()
    .rangeRound([height, 0]);

//Defines color scale
var color = d3.scale.ordinal()
    .range(["#005689", "#4bc6df"]);

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  	.attr("width", width + margin.left + margin.right)
  	.attr("height", height + margin.top + margin.bottom)
  	.append("g")
  	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Loads the data
d3.csv("data/terrorists_guns.csv", type, function(error, data) {
   if (error) throw error;

  	//Defines the blocks
  	var layers = d3.layout.stack()(causes.map(function(c) {
    	return data.map(function(d) {
      		return {x: d.date, y: d[c]};
    	});
  	}));

  	//Sets the xScale and yScale domains
  	xScale.domain(layers[0].map(function(d) { return d.x; }));
  	yScale.domain([0, d3.max(layers[layers.length - 1], function(d) { return d.y0 + d.y; })]).nice();

	//Deinfes axes
  	var xAxis = d3.svg.axis()
    	.scale(xScale)
    	.orient("bottom")
    	.tickFormat(d3.time.format("%Y"))
    	.tickValues(xScale.domain().filter(function(d, i) { return !(i % 2); }));

	var yAxis = d3.svg.axis()
    	.scale(yScale)
    	.tickSize(-width)
    	.orient("left");

  	//Binds the data to the blocks
  	var layer = svg.selectAll(".layer")
      	.data(layers)
    	.enter().append("g")
      	.attr("class", "layer")
      	.style("fill", function(d, i) { return color(i); });

  	//Appends the bars
  	var bars = layer.selectAll("rect")
      	.data(function(d) { return d; })
    	.enter().append("rect")
    	.attr("class", "rect")
      	.attr("x", function(d) { return xScale(d.x); })
      	.attr("y", function(d) { return yScale(d.y + d.y0); })
      	.attr("height", function(d) { return yScale(d.y0) - yScale(d.y + d.y0); })
      	.attr("width", xScale.rangeBand() - 1);

	//Appends the xAxis
  	svg.append("g")
      	.attr("class", "x axis")
      	.attr("transform", "translate(0," + height + ")")
      	.call(xAxis);

	//Appends the yAxis
  	svg.append("g")
      	.attr("class", "y axis")
      	.call(yAxis)
      	.selectAll("g")
	  	.classed("g-baseline", function(d) {return d == 0});

	//RESPONSIVENESS
d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 5, right: 5, bottom: 25, left: 37};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
    	.attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      	.rangeRoundBands([0, newWidth], 0.1);

    //Updates the bars
    d3.selectAll("rect")
      	.attr("x", function(d) { return xScale(d.x); })
      	.attr("y", function(d) { return yScale(d.y + d.y0); })
      	.attr("height", function(d) { return yScale(d.y0) - yScale(d.y + d.y0); })
      	.attr("width", xScale.rangeBand() - 1);
    
    //Updates xAxis
    d3.selectAll(".x.axis")
        .call(xAxis);     

    //Updates ticks
    xAxis
      	.scale(xScale)
      	.tickValues(xScale.domain().filter(function(d, i) { return !(i % 2); }));

    //Updates yAxis
    d3.selectAll(".y.axis")
      	.call(yAxis); 

    yAxis
      	.tickSize(-newWidth);
  };  	

});

function type(d) {
	d.date = parseDate(d.date);
  	causes.forEach(function(c) { d[c] = +d[c]; });
  	return d;
}
